import { match } from 'ts-pattern';

import type { ProcessingStatusCardProps } from '../transaction-details/ProcessingStatusCard';

export type TransactionProcessMessageOverrides = Partial<
  Record<ProcessingStatusCardProps['status'], React.ReactNode>
>;

export const TransactionProcessMessage = ({
  status,
  messageOverrides,
}: {
  status: ProcessingStatusCardProps['status'];
  messageOverrides?: TransactionProcessMessageOverrides;
}) => {
  const override = messageOverrides?.[status] || null;

  return match(status)
    .with('pending', () => (
      <p className="text-secondary flex flex-col text-center text-xs">
        {override || (
          <>
            <span>We'll keep processing this in the background.</span>
            <span>You can safely close this window.</span>
          </>
        )}
      </p>
    ))
    .with('error', () => (
      <p className="text-emphasis flex flex-col text-center text-xs font-medium">
        {override || (
          <>
            <span>There was an issue processing the transaction.</span>
            <span>Please try again.</span>
          </>
        )}
      </p>
    ))
    .with('wait-for-approval', () => override)
    .with('success', () => override)
    .with('partial', () => override)
    .with('review', () => override)
    .exhaustive();
};
